<template>
    <Layout>
        <template v-slot:title>
            <h1>Order List: {{ user.name }}</h1>
            <div class="pt-2 text-red text-bold">Records found: {{ totalItems }}</div>
        </template>
        <template v-slot:content>
            <Loader v-if="isLoading" />
            <div class="row mb-4">
                <div class="col-sm-6 col-md-4 col-xl-3 mb-2 mb-md-0">
                    <form @submit.prevent="onSearch" class="input-group btn-inline">
                        <input
                            v-model="keyword"
                            name="table_search"
                            class="form-control float-right"
                            placeholder="Search order ID"
                            type="text"
                        />

                        <div class="input-group-append">
                            <button type="submit" class="btn btn-default">
                                <f-icon icon="search" />
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-3 mb-4 mb-md-0">
                    <select class="form-control" v-model="mothodType" @change="filterByMethod">
                        <option value="">Filter by method</option>
                        <option v-for="method in paymentMethods" :value="method.value" :key="method.value">
                            {{ method.label }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-3 mb-4 mb-md-0">
                    <select class="form-control" v-model="filterType" @change="filterByType">
                        <option value="">Filter by type</option>
                        <option v-for="paymentType in paymentTypes" :value="paymentType.value" :key="paymentType.value">
                            {{ paymentType.label }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row" v-if="orders.length">
                <div class="col-lg-12">
                    <div class="table-responsive tbq-table-responsive">
                        <table class="table tbq-table">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Gateway</th>
                                    <th>Payer</th>
                                    <th>Amount</th>
                                    <th>Quiz</th>
                                    <th>Expire Date</th>
                                    <th style="width: 10%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="order in orders" :key="order._id.$oid">
                                    <td>
                                        <p class="mb-0 text-bold">{{ setNameOrder(order) }}</p>
                                        <p class="mb-0">{{ order.order_id }}</p>
                                        <div v-if="getCampaign(order.campaign)">
                                            <small style="color: #c82333; font-weight: 700">Coupon campaign: </small>
                                            <small style="color: #c82333">{{ getDataCampaign(order.campaign) }}</small>
                                        </div>
                                        <small>Created At {{ order.created_at }}</small>
                                    </td>
                                    <td>
                                        <p
                                            :class="{
                                                'mb-0 ucfirst': true,
                                                'text-paypal': order.method == 'paypal',
                                                'text-stripe': order.method == 'stripe-checkout',
                                                'text-vipps': order.method == 'vipps'
                                            }"
                                        >
                                            {{ order.method.replace(/-checkout/gi, '') }}
                                        </p>
                                    </td>
                                    <td>
                                        {{ order.user.name }}
                                        <i v-if="!order.user.name">[This user unregistered]</i>
                                    </td>
                                    <td>
                                        <div class="d-block">
                                            <p class="mb-0">
                                                <span v-if="order.currency && order.currency === 'NOK'">
                                                    {{ moneyNokFormat(order.amount) }}
                                                </span>
                                                <span v-else>
                                                    {{ moneyUsdFormat(order.amount) }}
                                                </span>
                                            </p>
                                            <small v-if="order.type == 'buy-credit'">{{ order.credits }} credit(s)</small>
                                            <small v-else>{{ order.data.limit_player }} player(s)</small>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="order.quiz">
                                            <a
                                                @click.prevent="filterByQuiz(order.quiz._id.$oid)"
                                                href="javascript:void(0)"
                                                class="cursor-pointer"
                                            >
                                                {{ order.quiz.title }}
                                            </a>
                                        </span>
                                        <span v-if="order.quiz_id == 'edit_question'">[From Edit Question]</span>
                                    </td>
                                    <td>
                                        <DiscIcon
                                            v-if="order.type === 'buy-player'"
                                            :class="{ 'text-gray': !order.is_active, 'text-green': order.is_active }"
                                            size="1x"
                                        />
                                        <span v-if="order.type === 'buy-player'">{{ order.expires_at }}</span>
                                    </td>
                                    <td>
                                        <div class="text-center" v-if="order.type === 'buy-player'">
                                            <button
                                                v-if="order.buy_player_status != 'suspend'"
                                                @click.stop="suspendBuyOrder(order.order_id)"
                                                class="btn btn-danger text-center p-2 btn-sm"
                                            >
                                                Suspend
                                            </button>
                                            <div v-else class="text-red text-center p-2">Suspended</div>
                                        </div>

                                        <div v-else>
                                            <div
                                                v-if="order.subscription_status == 'active' && order.user"
                                                class="d-flex justify-content-center"
                                            >
                                                <button
                                                    v-if="order.order_id"
                                                    @click.stop="unsubscribe(order.order_id)"
                                                    class="btn btn-sm btn-warning mr-2"
                                                >
                                                    Unsubscribe
                                                </button>
                                                <button
                                                    @click.stop="suspend(order.order_id, order._id.$oid)"
                                                    class="btn btn-sm btn-danger"
                                                >
                                                    Suspend
                                                </button>
                                            </div>
                                            <div
                                                v-else-if="order.subscription_status == 'unsubscribe'"
                                                class="text-center"
                                            >
                                                <small class="text-gray d-block mt-2" v-if="order['expires_at']">
                                                    Expire Date: {{ order['expires_at'].split(' ').shift() }}
                                                </small>
                                            </div>
                                            <div v-else disabled class="text-red text-center p-2">
                                                <span v-if="order.type !== 'ai-question' && order.type !== 'buy-credit'">Suspend</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="orders.length" class="col-12 my-3">
                <Paginator
                    @change="onPageChange"
                    :current-page="currentPage"
                    :page-count="pageCount"
                    :total-items="totalItems"
                />
            </div>
            <EmptyList v-if="isEmpty" :label="emptyLabel" />
        </template>
    </Layout>
</template>

<script>
import API_URL from '@/router/api'
import Url from '@/service/url'
import Layout from '@/components/Layout'
import Paginator from '@/components/Paginator'
import Loader from '@/components/Loader'
import EmptyList from '@/components/EmptyList'
import axios from 'axios'
import { DiscIcon } from 'vue-feather-icons'
import appConfig from '@/app.config'
import orderMixin from '@/mixins/order'

export default {
    name: 'user-order',

    mixins: [orderMixin],

    components: {
        Layout,
        Loader,
        EmptyList,
        Paginator,
        DiscIcon
    },

    data() {
        return {
            keyword: '',
            isLoading: false,
            currentPage: 1,
            pageCount: 0,
            totalItems: 0,
            isEmpty: false,
            orders: [],
            paymentMethods: appConfig.payment_method,
            paymentTypes: [
                { label: 'Buy Player', value: 'buy-player' },
                { label: 'Buy Credit', value: 'buy-credit' },
                { label: 'Buy AI Questions', value: 'buy-ai-questions' },
                { label: 'Subscription', value: 'subscription' }
            ],
            onlyActive: false,
            mothodType: '',
            filterType: '',
            emptyLabel: 'No order found.',
            user: {}
        }
    },

    watch: {
        $route() {
            this.setParams()
        }
    },

    mounted() {
        this.setParams()
        this.findUserById()
    },

    methods: {
        async onSearch() {
            const url = new Url()
            const query = url.getQuery()

            if (query.keyword == this.keyword) {
                return
            }

            await this.$router.push({
                name: 'user.order-list',
                params: {
                    id: this.$route.params.id
                },
                query: {
                    ...query,
                    ...{ keyword: this.keyword },
                    ...{ page: 1 }
                }
            })
        },

        async filterByMethod(event) {
            const url = new Url()
            const query = url.getQuery()

            if (query.method == event.target.value) {
                return
            }

            await this.$router.push({
                name: 'user.order-list',
                params: {
                    id: this.$route.params.id
                },
                query: {
                    ...query,
                    ...{ method: event.target.value },
                    ...{ page: 1 }
                }
            })
        },

        async filterByType(event) {
            const url = new Url()
            const query = url.getQuery()

            if (query.type == event.target.value) {
                return
            }

            await this.$router.push({
                name: 'user.order-list',
                params: {
                    id: this.$route.params.id
                },
                query: {
                    ...query,
                    ...{ type: event.target.value },
                    ...{ page: 1 }
                }
            })
        },

        setParams() {
            const url = new Url()
            const query = url.getQuery()

            this.fetchOrder(query)

            this.onlyActive = typeof query.onlyActive != 'boolean' ? query.onlyActive == 'true' : query.onlyActive
            this.mothodType = query.method || ''
            this.keyword = query.keyword || ''
            this.filterType = query.type || ''
        },

        fetchOrder(query) {
            this.isLoading = true
            this.isEmpty = false

            axios
                .get(API_URL.order.list, {
                    params: Object.assign(query, { user_id: this.$route.params.id })
                })
                .then(res => {
                    this.isLoading = false
                    this.orders = res.data.data.data

                    if (!this.orders.length) {
                        this.isEmpty = true
                    }

                    this.pageCount = res.data.data.page_count
                    this.totalItems = res.data.data.total
                    this.currentPage = parseInt(res.data.data.current_page)
                })
                .catch(() => {
                    this.isLoading = false
                })
        },

        findUserById() {
            this.isLoading = true

            this.$store
                .dispatch('user/findById', this.$route.params.id)
                .then(res => {
                    this.user = res.data.data
                })
        },

        onPageChange(page) {
            const url = new Url()
            const query = url.getQuery()

            if (query.page == page) {
                return
            }

            this.$router.push({
                name: 'user.order-list',
                params: {
                    id: this.$route.params.id
                },
                query: Object.assign(query, {
                    page
                })
            })
        },

        filterByQuiz(quizId) {
            const url = new Url()
            const query = url.getQuery()

            if (query.quiz_id == quizId) {
                return
            }

            this.$router.push({
                name: 'user.order-list',
                params: {
                    id: this.$route.params.id
                },
                query: {
                    quiz_id: quizId
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/order.scss';
</style>

